<template>
  <main class="container">
    <ExploreNav></ExploreNav>

			<ul class="row" aria-label="Liste over anbefalede steder og temaer">
        <template v-for="(child,index) in recommendedData">
          <RecommendedChild :childData="child" :tagList="tagList" :searchDataExpanded="searchDataExpanded" :index="index" :key="index"></RecommendedChild>
        </template>
			</ul>

  </main>
</template>

<script>
import ExploreNav from '@/components/ExploreNav.vue'
import RecommendedChild from '@/components/RecommendedChild.vue'
import DataManager from '@/assets/DataManager.js'
import SearchDataParser from '@/assets/SearchDataParser.js'

export default {
  data() {
    return {
      recommendedData: [],
      tagList: [],
      searchDataExpanded: []
    }
  },
  components: {
    ExploreNav, RecommendedChild,
  },
  created: function() {
    DataManager.getData([
        DataManager.recommendData,
        DataManager.tagList,
        DataManager.searchData,
        DataManager.searchDataExpanded
      ], (r) => {

      this.recommendedData = r[0].data;
      this.tagList = r[1].data;
      this.searchDataExpanded = SearchDataParser(r[2].data, r[3].data).searchDataExpanded;
    });
    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Anbefalet');
  },
  mounted: function() {
    document.getElementById('recommended-tab').classList.add('active');
  }
}
</script>

<style lang="scss" scoped>

</style>
